/* eslint no-eval: 0 */

import { useEffect, useCallback, useState } from "react";
import {
  AppCode,
  SubAppCode,
  ExpertModeTypes,
  /*ProductionMode,*/ SystemCode,
} from "./consts";
import { deepCopy, isSameObject, isSubsetEqual, isEmpty } from "./utils";
import { api } from "../../api";
import valeurParDefaut from "./valeurParDefaut.json";
import zone4Defaults from "./zone4Defaults.json";
import filtreDefault from "./filtreDefault.json";
import { env } from "../../env";
import { calcFieldTypes } from "components/EtudeForm/constants";
import { InstallationType } from "components/EtudeForm/hooks/useGetSolutionsQuery";

// eslint-disable-next-line no-unused-vars
// const showMessage = (text) => {
//     notification.info({
//         message: `Notification`,
//         description: text,
//         placement: 'top',
//         duration: 0,
//         key: "engineMessage"
//     });
// }

const excludeChange = (key, system, value, parentValue) => {
  switch (system) {
    case SystemCode.BALLONS_ECS_TANK_IN_TANK:
    case SystemCode.BALLONS_ECS_PREPARATEURS:
      if (key === "Tp") {
        return !(
          (parentValue === 65 && value === 70) ||
          (parentValue === 70 && (value === 70 || value === 75)) ||
          (parentValue === 75 && value !== 90)
        );
      }
      break;
    case SystemCode.ECHANGEUR_BALLONS_ECS:
      if (key === "Tp") {
        return !(parentValue === 65 && value === 65);
      }
      break;
    default:
      break;
  }

  return false;
};

export const isSubAppField = (fieldName, subApp) => {
  return calcFieldTypes[subApp][fieldName] !== undefined;
};

export const isExpertModeField = (field, subApp) => {
  let expertModeFields = [];

  switch (subApp) {
    case SubAppCode.LOGEMENTSPRIVES:
    case SubAppCode.LOGEMENTSSOCIAUX:
      expertModeFields = [
        "consoT1",
        "consoT2",
        "consoT3",
        "consoT4",
        "consoT5",
        "consoT6",
        "consoBatiment",
      ];
      break;
    case SubAppCode.RESIDENCESSENIORS:
      expertModeFields = ["consoT1", "consoBatiment"];
      break;
    case SubAppCode.RESIDENCESETUDIANTE:
    case SubAppCode.FOYERDEJEUNESTRAVAILLEURS:
      expertModeFields = ["Cjpl", "ECSbyCouv", "tRestau", "Simult"];
      break;
    case SubAppCode.CAMPING:
      expertModeFields = ["PfB", "NbL", "NbBV", "NbBL"];
      break;
    case SubAppCode.AFFAIRES:
    case SubAppCode.MONTAGNE:
    case SubAppCode.TOURISME:
      expertModeFields = ["Cjpc", "ECSbyCouv", "tRestau", "Simult"];
      break;
    case SubAppCode.STADEFOOTBALL:
    case SubAppCode.STADERUGBY:
      expertModeFields = ["TpsEcDch", "TpsTotDch", "QDch"];
      break;
    case SubAppCode.GYMNASE:
      expertModeFields = ["TpsEcDch", "TpsTotDch", "QDch", "TpsSesDch"];
      break;
    case SubAppCode.INTERNAT:
      expertModeFields = ["QDch", "TpsEcDch", "TpsTotDch", "ConsoJourLit"];
      break;
    case SubAppCode.TRADITIONNEL:
    case SubAppCode.GASTRONOMIQUE:
    case SubAppCode.RAPIDE:
    case SubAppCode.COLLECTIF:
      expertModeFields = ["ECSbyRepas", "tRestau"];
      break;
    case SubAppCode.HOPITALCLINIQUEDOUCHES:
    case SubAppCode.EHPAD:
      expertModeFields = ["VJRef"];
      break;
    case SubAppCode.VESTIAIREDENTREPRISE:
      expertModeFields = ["QDch", "TpsEcDch", "TpsTotDch"];
      break;
    case SubAppCode.CASERNE:
      expertModeFields = ["QDch", "TpsEcDch", "TpsTotDch", "PointeModif"];
      break;
    case SubAppCode.STATIONDELAVAGE:
      expertModeFields = [
        "TpsBrosse",
        "TpsHp",
        "TpsRinc",
        "TpsSSPuis",
        "NbPuisages",
      ];
      break;
    case SubAppCode.SALLEDEFITNESS:
    case SubAppCode.PISCINE:
      expertModeFields = [
        "NbPuisages",
        "TpsAffl",
        "Affl",
        "NAffl",
        "QDch",
        "TpsEcDch",
        "TpsTotDch",
      ];
      break;

    // no default
  }

  return expertModeFields.indexOf(field) !== -1;
};
/**
 * @returns {{ loading: any;  defaultData: any;  calculatedData: any;  allData: any;  setAllData: any;  sendRequest: any;  expertModeChanged: any;  setExpertModeChanged: any;  isValid: any;  setIsValid: any;  setCalculatedData: any;  allowMessages: any;  setAllowMessages: any;}}
 */
export const useEngine = ({
  application,
  subapplication,
  productionMode,
  system,
  data,
  resetExpertMode,
  installationType,
  location,
}) => {
  const [defaultData, setDefaultData] = useState(null);
  const [calculatedData, setCalculatedData] = useState(null);
  const [allData, setAllData] = useState(null);
  const [expertModeChanged, setExpertModeChanged] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const [allowMessages, setAllowMessages] = useState(false);
  const [isShowLoader, setIsShowLoader] = useState(false);

  const showLoader = () => {
    setIsShowLoader(true);
  };

  const hideLoader = () => {
    setIsShowLoader(false);
  };

  const isDefaultCalculatable = (key, defaults) => {
    let script = "";
    let _defaultsData = {};
    _defaultsData[key] = { ...defaults[key] };

    if (
      typeof _defaultsData[key].default === "string" &&
      defaults[key].default === "empty"
    ) {
      return false;
    } else {
      if (
        typeof _defaultsData[key].default === "string" &&
        _defaultsData[key].params &&
        (_defaultsData[key].params.filter((p) =>
          new RegExp(p).test(_defaultsData[key].default)
        ).length ||
          /minimum|maximum/.test(_defaultsData[key].default))
      ) {
        return true;
      }
    }
  };

  const getMinimum = useCallback((_data, key) => {
    let script = "";
    let expression = "";
    let tempData = {};

    if (_data[key].params) {
      //_data[key].params.forEach((p) => { script += `let ${p}=${_data[p].default || 0};` })
      _data[key].params.forEach((p) => {
        tempData[p] = (_data[p] && _data[p].default) || 0;
      });

      script = `const {${_data[key].params.join(",")}} = this;`;

      if (
        _data[key].minimum instanceof Array ||
        _data[key].params.filter((p) => new RegExp(p).test(_data[key].minimum))
          .length
      ) {
        if (_data[key].minimum instanceof Array) {
          expression = _data[key].minimum
            .slice(0, _data[key].minimum.length - 1)
            .join(";");
          expression +=
            "; return " + _data[key].minimum[_data[key].minimum.length - 1];
        } else {
          expression = "; return " + _data[key].minimum;
        }

        script += expression;
        // eslint-disable-next-line no-new-func
        let f = new Function(script); //NOSONAR
        return Math.round(f.call(tempData));
      }
    }

    return _data[key].minimum;
  }, []);

  const calculate = useCallback(
    (defaults) => {
      if (!defaults) {
        return {};
      }
      //NOSONAR
      let keys = Object.keys(defaults);
      let _defaultsData = {};
      let tempData = {};

      for (let i = 0; i < keys.length; i++) {
        //NOSONAR
        let key = keys[i];
        let script = "";
        _defaultsData[key] = { ...defaults[key] };

        switch (typeof _defaultsData[key].default) {
          case "string":
            if (defaults[key].default === "empty") {
              _defaultsData[key].default = "";
            } else {
              if (
                _defaultsData[key].params &&
                (_defaultsData[key].params.filter((p) =>
                  new RegExp(p).test(_defaultsData[key].default)
                ).length ||
                  /minimum|maximum/.test(_defaultsData[key].default))
              ) {
                let hasMinimumParam = /minimum/.test(
                  _defaultsData[key].default
                );
                if (hasMinimumParam) {
                  tempData.minimum = getMinimum(_defaultsData, key);
                }

                script = `const {${_defaultsData[key].params.join(",") +
                  (hasMinimumParam ? ", minimum" : "")
                  }} = this; return ${defaults[key].default}`;

                // eslint-disable-next-line no-new-func
                let f = new Function(script); //NOSONAR
                let val = f.call(tempData);

                _defaultsData[key].default = val ? Math.round(val) : "";
              }
            }
            break;
          case "object":
            let objKey = _defaultsData[_defaultsData[key].keyName]?.default;
            if (objKey) {
              if (_defaultsData[key].params) {
                let s = null;
                if (_defaultsData[key].default) {
                  if (typeof _defaultsData[key].default[objKey] === "object") {
                    if (!_defaultsData[key].default[objKey]) {
                      s = 0;
                    } else {
                      s = _defaultsData[key].default[objKey].default;
                    }
                  } else {
                    s = _defaultsData[key].default[objKey];
                  }
                } else {
                  s = 0;
                }

                script = `const {${_defaultsData[key].params.join(
                  ","
                )}} = this; return ${s}`;

                // eslint-disable-next-line no-new-func
                let f = new Function(script); //NOSONAR
                let val = f.call(tempData);
                _defaultsData[key].default = val ? Math.round(val) : "";
              } else {
                if (_defaultsData[key].less) {
                  for (let i = 0; i < _defaultsData[key].less.length; i++) {
                    if (objKey < _defaultsData[key].less[i]) {
                      objKey = _defaultsData[key].less[i];
                      break;
                    }
                  }
                }
                // objKey = 5; piti vercnem _defaultsData[key].default i en keyov@
                let value = _defaultsData[key].default[objKey];

                if (typeof value === "object") {
                  _defaultsData[key] = _defaultsData[key].default[objKey];
                } else {
                  _defaultsData[key].default =
                    _defaultsData[key].default[objKey];
                }
              }
            } else {
              _defaultsData[key].default = "";
            }

            break;
          case "undefined":
            break;
          default:
            break;
        }

        tempData[key] = _defaultsData[key].default || 0;
      }

      return _defaultsData;
    },
    [getMinimum]
  );

  const getDefaults = useCallback(() => {
    let defaults, _defaultsData;

    if (application && subapplication) {
      defaults = valeurParDefaut["applications"][application][subapplication];
    }

    if (productionMode && system) {
      defaults = valeurParDefaut["systems"][productionMode][system];
    }

    _defaultsData = calculate(defaults);

    return _defaultsData;
  }, [application, subapplication, productionMode, system, calculate]);

  /* NOTE:
        const getMaximum = useCallback((_data, key) => { //NOSONAR
        let script = "";
        if (_data[key].params) {
            _data[key].params.forEach((p) => { script += `let ${p}=${_data[p].default || 0};` });

            if (_data[key].maximum instanceof Array || _data[key].params.filter((p) => new RegExp(p).test(_data[key].maximum)).length) {
                if (_data[key].maximum instanceof Array) {
                    script += _data[key].maximum.join(";");
                } else {
                    script += _data[key].maximum;
                }
                return Math.round(eval(script));
            }
        }

        return _data[key].maximum;
    }, []);*/

  const calculateMinMax = useCallback((_data, originalJson) => {
    //NOSONAR
    let _isValid = true;
    let newData = deepCopy(_data);

    let keys = Object.keys(_data);
    for (let i = 0; i < keys.length; i++) {
      //NOSONAR
      let key = keys[i];
      let script = "",
        expression = "";

      let tempData = {};
      let paramsArr = _data[key].params || [];
      let minMaxParamArr = _data[key].minMaxParams || [];

      if (
        typeof _data[key].minimum === "object" &&
        !(_data[key].minimum instanceof Array)
      ) {
        if (originalJson) {
          newData[key].default = originalJson[key].default;
          let fieldDefault = calculate(newData)[key].default;
          tempData._default = fieldDefault || 0;
          _data[key].minimum = _data[key].minimum.default;
        }
      }

      if (
        typeof _data[key].maximum === "object" &&
        !(_data[key].maximum instanceof Array)
      ) {
        if (originalJson) {
          newData[key].default = originalJson[key].default;
          let fieldDefault = calculate(newData)[key].default;
          tempData._default = fieldDefault || 0;
          _data[key].maximum = _data[key].maximum.default;
        }
      }

      if (
        paramsArr.length ||
        minMaxParamArr.length ||
        Object.keys(tempData).length
      ) {
        paramsArr.forEach((p) => {
          tempData[p] = _data[p].default || 0;
          //params += `let ${p}=${_data[p].default || 0};`
        });

        minMaxParamArr.forEach((p) => {
          tempData[`${p}Min`] = _data[p].minimum || 0;
          tempData[`${p}Max`] = _data[p].maximum || 0;
          //params += `let ${p}Min=${_data[p].minimum || 0}; let ${p}Max=${_data[p].maximum || 0};`
        });

        let allKeys = Object.keys(tempData);

        if (
          _data[key].minimum &&
          (_data[key].minimum instanceof Array ||
            allKeys.filter((p) => new RegExp(p).test(_data[key].minimum))
              .length)
        ) {
          //script = params
          script = `const {${Object.keys(tempData).join(",")}} = this;`;

          if (_data[key].minimum instanceof Array) {
            //script += _data[key].minimum.join(";")
            expression = _data[key].minimum
              .slice(0, _data[key].minimum.length - 1)
              .join(";");
            expression +=
              "; return " + _data[key].minimum[_data[key].minimum.length - 1];
          } else {
            //script += _data[key].minimum
            expression = "; return " + _data[key].minimum;
          }
          script += expression;

          // eslint-disable-next-line no-new-func
          let f = new Function(script); //NOSONAR
          _data[key].minimum = Math.round(f.call(tempData));

          if (
            _data[key].default &&
            _data[key].default < _data[key].minimum &&
            _isValid
          ) {
            _isValid = false;
            setIsValid(false);
          }
        } else if (
          _data[key].default &&
          _data[key].default &&
          _data[key].minimum &&
          _isValid
        ) {
          //NOSONAR
          if (_data[key].default < _data[key].minimum) {
            _isValid = false;
            setIsValid(false);
          }
        }

        if (
          _data[key].maximum &&
          (_data[key].maximum instanceof Array ||
            allKeys.filter((p) => new RegExp(p).test(_data[key].maximum))
              .length ||
            minMaxParamArr.length)
        ) {
          //script = params
          script = `const {${Object.keys(tempData).join(",")}} = this;`;

          if (_data[key].maximum instanceof Array) {
            expression = _data[key].maximum
              .slice(0, _data[key].maximum.length - 1)
              .join(";");
            expression +=
              "; return " + _data[key].maximum[_data[key].maximum.length - 1];
            //script += _data[key].maximum.join(";")
          } else {
            //script += _data[key].maximum
            expression = "; return " + _data[key].maximum;
          }

          script += expression;

          // eslint-disable-next-line no-new-func
          let f = new Function(script); //NOSONAR
          _data[key].maximum = Math.round(f.call(tempData));
          //_data[key].maximum = Math.round(eval(script))

          if (_data[key].default > _data[key].maximum && _isValid) {
            _isValid = false;
            setIsValid(false);
          }
        } else if (_data[key].maximum) {
          if (
            _data[key].default &&
            _data[key].default > _data[key].maximum &&
            _isValid
          ) {
            _isValid = false;
            setIsValid(false);
          }
        }
      } else {
        if (
          _data[key].default &&
          ((_data[key].maximum && _data[key].default > _data[key].maximum) ||
            (_data[key].minimum && _data[key].default < _data[key].minimum)) &&
          _isValid
        ) {
          _isValid = false;
          setIsValid(false);
        }
      }
    }

    return _data;
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const mapDefaultsToData = useCallback((defaults) => {
    let d = {};
    Object.keys(defaults).map((key) => (d[key] = defaults[key].default)); //NOSONAR

    return d;
  }, []);

  const isFieldChanged = useCallback((newData, oldData, field) => {
    return newData[field] !== oldData[field];
  }, []);

  useEffect(() => {
    if (
      SubAppCode.isValid(subapplication) ||
      (system && SystemCode.isValid(system))
    ) {
      const defaults = getDefaults();
      setDefaultData(defaults);

      if (!data || !Object.keys(data).length) {
        /*NOTE: Arman must be delete
                setCalculatedData(mapDefaultsToData(defaults));
                setAllData(calculateMinMax(defaults));*/
      } else {
        if (defaults.Pboucle && (data.Pboucle || data.Pboucle === 0)) {
          defaults.Pboucle.default = data.Pboucle;
        }
      }

      let originalJson = null;

      if (application && subapplication) {
        setExpertModeChanged(false);
        originalJson = deepCopy(
          valeurParDefaut["applications"][application][subapplication]
        );
      }

      setCalculatedData(mapDefaultsToData(defaults));
      setAllData(calculateMinMax(defaults, originalJson));
    }
  }, [subapplication, system, calculateMinMax, mapDefaultsToData, getDefaults]); // eslint-disable-line react-hooks/exhaustive-deps

  const getDefaultOptions = (_defaults, _field, _data) => {
    let text;
    let defaultOptions = {};

    if (
      _defaults[_field].default !== null &&
      typeof _defaults[_field].default === "object"
    ) {
      let objKey = _data[_defaults[_field].keyName];
      if (_defaults[_field].less) {
        for (let i = 0; i < _defaults[_field].less.length; i++) {
          if (objKey < _defaults[_field].less[i]) {
            objKey = _defaults[_field].less[i];
            break;
          }
        }
      }

      let d = _defaults[_field].default[objKey];

      if (typeof d === "object") {
        text = d.default;

        defaultOptions = d;
      } else {
        text = d;
        defaultOptions.default = d;
      }
    } else {
      text = _defaults[_field].default;
      defaultOptions.default = text;
    }

    defaultOptions.defaultContainsParam =
      !!(
        _defaults[_field].params &&
        _defaults[_field].params.filter((p) => new RegExp(p).test(text)).length
      ) || new RegExp("minimum").test(text); //NOSONAR

    return defaultOptions; /*NOSONAR*/

    /*return !!_defaults[_field].params.filter((p) => new RegExp(p).test(text)).length*/
  };

  useEffect(() => {
    //NOSONAR
    const timeout = setTimeout(() => {
      if (!SubAppCode.isValid(subapplication) && system === undefined) {
        !data && setCalculatedData({});
      } else {
        if (data) {
          // first time calculatedData is null
          if (!calculatedData) {
            if (SubAppCode.isValid(subapplication)) {
              let originalJson = deepCopy(
                valeurParDefaut["applications"][application][subapplication]
              );
              const defaults = getDefaults();
              // setDefaultData(defaults);
              setCalculatedData(mapDefaultsToData(defaults));
              // setAllData(calculateMinMax(defaults, originalJson));
            }
          }
          if (calculatedData && !isSubsetEqual(data, calculatedData)) {
            let _data = { ...data };
            let defaults, keys, _defaultsData;
            let changedExpertModeField = null;
            let changedExpertModeFields = [];

            setIsValid(true);

            if (application) {
              setAllowMessages(true);
              defaults = deepCopy({
                // ...defaults,
                ...valeurParDefaut["applications"][application][subapplication],
              });
              let originalJson = deepCopy({
                // ...defaults,
                ...valeurParDefaut["applications"][application][subapplication],
              });

              keys = Object.keys(defaults || {});

              for (let i = 0; i < keys.length; i++) {
                //NOSONAR
                let key = keys[i];

                if (resetExpertMode && isExpertModeField(key, subapplication)) {
                  setExpertModeChanged(false);
                  continue;
                }

                let defaultOptions = getDefaultOptions(defaults, key, data);

                if (data[key] === calculatedData[key]) {
                  if (
                    defaults[key].params &&
                    defaultOptions.defaultContainsParam
                  ) {
                    //stugel ete params uni u peramsic inch vor mek@ defaulti hashvarknerum ka
                    if (
                      !defaults[key].params.filter(
                        (p) =>
                          new RegExp(p).test(defaultOptions.default) &&
                          isFieldChanged(_data, calculatedData, p)
                      ).length &&
                      (!defaults[key].keyName ||
                        data[defaults[key].keyName] ===
                        calculatedData[defaults[key].keyName])
                    ) {
                      defaults[key].default = data[key]; //defaultOptions.enum && (defaults[key] = defaultOptions)
                    }
                  } else {
                    if (defaults[key].keyName) {
                      if (
                        data[defaults[key].keyName] ===
                        calculatedData[defaults[key].keyName]
                      ) {
                        defaults[key].default = data[key];
                        defaultOptions.enum &&
                          (defaults[key].enum = defaultOptions.enum);
                      } else {
                        let objKey = data[defaults[key].keyName];

                        if (defaults[key].less) {
                          for (let i = 0; i < defaults[key].less.length; i++) {
                            if (objKey < defaults[key].less[i]) {
                              objKey = defaults[key].less[i];
                              break;
                            }
                          }
                        }

                        let _d = defaults[key].default[objKey];

                        if (typeof _d === "object") {
                          defaults[key] = _d;
                        } else {
                          if (_d) {
                            defaults[key].default = _d;
                          } else {
                            defaults[key].default = null;
                          }
                          //ete default@ objecta u tvyal key ov arjeq chka ban chenq anum
                        }
                      }
                    } else {
                      defaults[key].default = data[key];
                    }
                  }
                } else {
                  if (isExpertModeField(key, subapplication)) {
                    setExpertModeChanged(true);
                    changedExpertModeField = key;
                    changedExpertModeFields.push(key);
                  }

                  /* NOTE:
                                     * if (defaults[key].keyName) { //NOSONAR
                                       defaults[key] = defaults[key].default[data[defaults[key].keyName]];
                                       defaults[key].default = data[key];
                                    } else {
                                    }*/
                  defaults[key].default = data[key];
                  defaultOptions.enum &&
                    (defaults[key].enum = defaultOptions.enum);
                }
              }
              _defaultsData = calculate(defaults, data, calculatedData);
              setCalculatedData(mapDefaultsToData(_defaultsData));
              setAllData(calculateMinMax(_defaultsData, originalJson));

              if (changedExpertModeFields.length) {
                const defaultsOriginal = getDefaults();
                changedExpertModeFields.forEach((field) => {
                  defaults[field] = originalJson[field];
                });

                _defaultsData = calculate(defaults, data, calculatedData);

                if (
                  changedExpertModeFields.some(
                    (field) => _defaultsData[field]?.default == data[field]
                  )
                ) {
                  setExpertModeChanged(false);
                }
              }
            }

            if (productionMode && system) {
              defaults = deepCopy({
                ...defaults,
                ...valeurParDefaut["systems"][productionMode][system],
              });
              keys = Object.keys(defaults);

              for (let i = 0; i < keys.length; i++) {
                //NOSONAR
                let key = keys[i];
                let defaultOptions = getDefaultOptions(defaults, key, data);
                if (data[key] === calculatedData[key]) {
                  if (
                    defaults[key].params &&
                    defaultOptions.defaultContainsParam
                  ) {
                    //stugel ete params uni u peramsic inch vor mek@ defaulti hashvarknerum ka
                    if (
                      !defaults[key].params.filter((p) =>
                        isFieldChanged(_data, calculatedData, p)
                      ).length &&
                      (!defaults[key].keyName ||
                        data[defaults[key].keyName] ===
                        calculatedData[defaults[key].keyName])
                    ) {
                      defaults[key].default = data[key]; //defaultOptions.enum && (defaults[key] = defaultOptions)
                    }
                  } else {
                    if (defaults[key].keyName) {
                      if (
                        data[defaults[key].keyName] ===
                        calculatedData[defaults[key].keyName] ||
                        excludeChange(
                          key,
                          system,
                          data[key],
                          data[defaults[key].keyName]
                        )
                      ) {
                        defaults[key].default = data[key];
                        defaultOptions.enum &&
                          (defaults[key].enum = defaultOptions.enum);
                      } else {
                        let _d =
                          defaults[key].default[data[defaults[key].keyName]];

                        if (typeof _d === "object") {
                          defaults[key] = _d;
                        } else {
                          if (_d) {
                            defaults[key].default = _d;
                          } else {
                            defaults[key].default = null;
                          }
                          //ete default@ objecta u tvyal key ov arjeq chka ban chenq anum
                        }
                      }
                    } else {
                      defaults[key].default = data[key];
                    }
                  }
                } else {
                  defaults[key].default = data[key];
                  defaultOptions.enum &&
                    (defaults[key].enum = defaultOptions.enum);
                }
              }

              _defaultsData = calculate(defaults, data, calculatedData);
              setCalculatedData(mapDefaultsToData(_defaultsData));
              setAllData(calculateMinMax(_defaultsData));
            }
          }
        } else {
          if (SubAppCode.isValid(subapplication)) {
            let originalJson = deepCopy(
              valeurParDefaut["applications"][application][subapplication]
            );
            const defaults = getDefaults();
            setDefaultData(defaults);
            setCalculatedData(mapDefaultsToData(defaults));
            setAllData(calculateMinMax(defaults, originalJson));
          }
        }
      }
    }, 1000);

    return () => clearTimeout(timeout);
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

  const sendRequest = (data, url, success) => {
    showLoader();

    return api
      .post(url, data)
      .then((res) => {
        success?.();
        return res.data;
      })
      .finally(() => hideLoader());
  };

  return {
    loading: isShowLoader,
    defaultData,
    calculatedData,
    allData,
    setAllData,
    sendRequest,
    expertModeChanged,
    setExpertModeChanged,
    isValid,
    setIsValid,
    setCalculatedData,
    allowMessages,
    setAllowMessages,
  };
};

export const getZon4Defaults = (system, network, params) => {
  if (!network || !zone4Defaults[network]) {
    network = "default";
  }

  let defaults = deepCopy(zone4Defaults[network][system]);
  let allData = { ...defaults };

  let keys = Object.keys(defaults);

  for (let i = 0; i < keys.length; i++) {
    //NOSONAR
    let key = keys[i];

    if (typeof defaults[key] === "object") {
      defaults[key] = defaults[key].default;
    }

    if (/^this/.test(defaults[key])) {
      // eslint-disable-next-line no-new-func
      let f = new Function(`return ${defaults[key]}`); //NOSONAR
      defaults[key] = f.call(params); // eval(defaults[key])
    }
  }

  return { defaults, allData };
};

export const getZone4FieldNames = (system, network) => {
  if (!network || !zone4Defaults[network]) {
    network = "default";
  }

  let defaults = deepCopy(zone4Defaults[network][system]);

  let keys = Object.keys(defaults);

  return keys;
};

export const getZone1Data = (installationType, location, circuits) => {
  let defaults = {};
  let circuit = {};
  if (installationType) {
    defaults = {
      ...valeurParDefaut["localisation"],
    };
  }
  if (location) {
    defaults = { ...defaults, ...valeurParDefaut["installation"] };
  }

  if (installationType === "2") {
    circuits.map((c, index) => {
      circuit[`circuits[${index}].startTemperature`] =
        valeurParDefaut.installationType["hybride"]["startTemperature"];
      circuit[`circuits[${index}].puissance`] =
        valeurParDefaut.installationType["hybride"]["puissance"];
      circuit[`circuits[${index}].delta_t`] =
        valeurParDefaut.installationType["hybride"]["delta_t"];
      circuit[`circuits[${index}].surpuissance`] =
        valeurParDefaut.installationType["hybride"]["surpuissance"];
    });

    defaults = {
      ...defaults,
      ...circuit,
    };
  } else if (installationType === "1" && circuits && circuits.length > 0) {
    circuits.map((c, index) => {
      let t = c.type == "1" ? "regule" : "constant";

      if (t) {
        circuit[`circuits[${index}].startTemperature`] =
          valeurParDefaut.installationType["electric"]["type"][t][
          "startTemperature"
          ];
        circuit[`circuits[${index}].puissance`] =
          valeurParDefaut.installationType["electric"]["type"][t]["puissance"];
        circuit[`circuits[${index}].delta_t`] =
          valeurParDefaut.installationType["electric"]["type"][t]["delta_t"];
        circuit[`circuits[${index}].surpuissance`] =
          valeurParDefaut.installationType["electric"]["type"][t][
          "surpuissance"
          ];
      }
    });

    defaults = {
      ...defaults,
      ...circuit,
    };
  }

  let allData = { ...defaults };

  let keys = Object.keys(defaults);
  for (let i = 0; i < keys.length; i++) {
    //NOSONAR
    let key = keys[i];

    if (typeof defaults[key] === "object") {
      defaults[key] = defaults[key].default;
    }

    if (/^this/.test(defaults[key])) {
      // eslint-disable-next-line no-new-func
      let f = new Function(`return ${defaults[key]}`); //NOSONAR
      defaults[key] = f.call(params); // eval(defaults[key])
    }
  }

  return { defaults, allData };
};

export const getFiltresData = (network, service, installationType, params) => {
  if (!network || !filtreDefault[network]) {
    network = "ATLFR";
  }

  let instTypeName =
    installationType == InstallationType.electric
      ? "electric"
      : installationType == InstallationType.hybride
        ? "hybride"
        : null;

  let defaults = instTypeName
    ? deepCopy(filtreDefault[network][service][instTypeName])
    : deepCopy(filtreDefault[network][service]);
  let allData = { ...defaults };

  let keys = Object.keys(defaults);

  for (let i = 0; i < keys.length; i++) {
    //NOSONAR
    let key = keys[i];

    if (typeof defaults[key] === "object") {
      defaults[key] = defaults[key].default;
    }

    if (/^this/.test(defaults[key])) {
      // eslint-disable-next-line no-new-func
      let f = new Function(`return ${defaults[key]}`); //NOSONAR
      defaults[key] = f.call(params); // eval(defaults[key])
    }
  }
  const cleanedDefaults = Object.fromEntries(
    Object.entries(defaults).filter(([key, value]) => value !== "empty")
  );

  return { defaults: cleanedDefaults, allData };
};
